import React from "react";

// Classname
import clsx from "clsx";

// components
import Img from "components/Img";

// Interface
interface IHeader {
  count?: number;
  className?: string;
}

export const Header: React.FC<IHeader> = (props) => {
  const { count = 0, className = "" } = props;

  const cn = clsx(
    "chemical-probes__wrapper-header flex flex-ai-start flex-jc-between",
    className ? className : ""
  );

  return (
    <div className={cn}>
      <div className="chemical-probes__wrapper-header-left flex flex-direction-column">
        <h4 className="chemical-probes__title mb10">
          Chemical probes
        </h4>
        <div className="flex flex-ai-start">
          <p className="chemical-probes__sub-title mr10">
            Chemical probes are specific small molecules used in biological research to investigate the function and behavior of biomolecules within cells or organisms. These probes are designed to interact with their target molecules in a highly selective and often reversible manner, enabling researchers to modulate the activity of the target and study its biological effects. It is a gateway to understanding fundamental biological processes, aiding in developing first-in-class drugs.
          </p>
          <div className="chemical-probes__wrapper-fold-svg relative">
            <Img isSvg name="folderSvg" className="chemical-probes__fold-svg-3"/>
            <Img isSvg name="folderSvg" className="chemical-probes__fold-svg-2"/>
            <Img isSvg name="folderSvg" className="chemical-probes__fold-svg-1"/>
            <Img name="dimidrol" alt="Dimidrol" classNameWrapper="chemical-probes__dimidrol" />
          </div>
        </div>
      </div>

      <div className="chemical-probes__wrapper-header-right flex flex-ai-end flex-direction-column">
        <p className="chemical-probes__compounds">compounds</p>
        <p className="chemical-probes__count-compounds">{count}</p>
      </div>
    </div>
  );
};

export default Header;
